import { z } from 'zod';

// The exact set of tables the raw `GET /api/agent/rows/:table` endpoint
// exposes. This is the single source of truth shared by the web app (its
// table-name map) and the server (its allow-list) so the two can never drift
// — the drift that shipped a prod 400 when `coac_action_drafts` was present in
// the frontend map but missing from the server allow-list.
//
// It deliberately EXCLUDES the agent detector-finding tables: findings render
// via the aggregator / finding-card, and that endpoint bypasses `ctx.read`
// ACLs, so findings must never be reachable through this raw table read.
export const AGENT_ROW_TABLES = [
    'call_extracted_facts',
    'call_action_items',
    'call_kb_notes',
    'wealth_monthly_narrative_drafts',
    'wealth_portfolio_performance_snapshots',
    'suitability_letter_drafts',
    'onboarding_pack_drafts',
    'client_communication_drafts',
    'fund_report_drafts',
    'coac_action_drafts',
    'vulnerability_adaptation_plan_drafts',
    'governance_paper_drafts',
    'fair_value_assessment_drafts',
] as const;

export const agentRowTableSchema = z.enum(AGENT_ROW_TABLES);
export type AgentRowTable = z.infer<typeof agentRowTableSchema>;
